/**
 * Pure Redeem readiness — kept out of Game.ts so UI/legal-target code
 * does not create a circular import with the Game class module.
 */
import type { Presence } from "../cards/types";
import { isDogmaPresence } from "./dogma";
import { doubtCoreExposed, isDoubtPresence } from "./doubt";

/**
 * Redeem only after the claim has been answered once:
 * current intensity below the lie's spawn/max intensity.
 * Multiply spawnlings that enter below max are already "ready".
 * Doubt: core exposed (including core-only scaffold — always Redeemable).
 */
export function isLieRedeemable(p: Presence): boolean {
  if (p.side !== "enemy") return false;
  if (isDogmaPresence(p)) return false;
  if (isDoubtPresence(p) && p.doubt) {
    return doubtCoreExposed(p.doubt);
  }
  return p.level < p.maxLevel;
}
